import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    shelveContainer: {
        position: 'relative',
        background: 'url(/assets/shelve.png) no-repeat left bottom',
        backgroundSize: '100% 56px',
        height: '146px',
        paddingLeft: '8%',
        paddingRight: '8%',
        marginBottom: '16px',
        overflowX: 'auto',
    },
}));
